import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export const AppId = new Enum(['LOYALTY']);
export const AppFieldType = new Enum(['EMAIL_ADDRESS', 'PHONE_NUMBER', 'UNKNOWN', 'TEXT']);
export const LOYALTY_ACCOUNT_TOKEN_NAME = 'LoyaltyAccountToken';
export const LOYALTY_PHONE_TOKEN_NAME = 'LoyaltyPhoneToken';
export function getAppField(fields, appId, fieldName) {
  return (fields || []).find(field => field.appId === appId && field.name === fieldName);
}
export default ProtoBaseModel.extend({
  appId: attr(String),
  name: attr(String),
  type: attr(AppFieldType),
  textValue: attr(String)
});